import apiClient from './apiClient';

export const apiKeyApi = {
  list: () => apiClient.get('/api-keys').then(r => r.data),

  getScopes: () => apiClient.get('/api-keys/scopes').then(r => r.data),

  create: (data) => apiClient.post('/api-keys', data).then(r => r.data),

  update: (id, data) => apiClient.put(`/api-keys/${id}`, data).then(r => r.data),

  revoke: (id) => apiClient.post(`/api-keys/${id}/revoke`).then(r => r.data),

  delete: (id) => apiClient.delete(`/api-keys/${id}`).then(r => r.data),
};
